import React from "react";
interface IPropsSvg {
  fill: any;
  width?: any;
  height?: any;
}
export default function AntibioticIcon(props: IPropsSvg) {
  const { fill, width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "49.761"}
      height={height ? height : "49.783"}
      viewBox="0 0 49.761 49.783"
    >
      <defs>
        {/* <style>.a{fill:#0899ba;}.b,.c,.d{fill:none;stroke:#0899ba;stroke-miterlimit:10;}.b{stroke-width:1.5px;}.c{stroke-width:1.3px;}</style> */}
      </defs>
      <g transform="translate(-261.652 -500.666)">
        <g transform="translate(260 499)">
          <g transform="translate(0 0)">
            <path
              fill={fill}
              d="M29.329,54.591a9.486,9.486,0,0,1-1.548,3.775,8.276,8.276,0,0,1-8.386,3.252,8.185,8.185,0,0,1-6.49-6.58,6.454,6.454,0,0,1-.138-1.492q.011-7.669,0-15.334c0-.255.042-.467-.328-.554-.422-.107-.508-.494-.507-.911q.012-5.156,0-10.31c0-1.917-.018-3.834.007-5.75a9.13,9.13,0,0,1,17.922-1.963.641.641,0,0,0,.1.166,20.826,20.826,0,0,1,.223,3.726c0,.19-.01.378-.01.568v13.5c0,.453-.09.849-.554.99-.277.083-.277.223-.277.44q.011,6.232.012,12.465Q29.344,52.584,29.329,54.591ZM13.6,28.149c0,2.468.012,4.937-.011,7.405,0,.435.108.532.536.53q6.939-.025,13.877,0c.438,0,.532-.112.53-.537-.017-4.781-.011-9.556-.01-14.344a7.658,7.658,0,0,0-.084-1.082A7.455,7.455,0,0,0,13.6,21.21Zm.831,17.791v7.666a6.622,6.622,0,1,0,13.243-.115c.018-5.094,0-10.188.014-15.282,0-.385-.086-.481-.475-.479q-6.165.025-12.326,0c-.415,0-.465.132-.463.492.022,2.572.015,5.145.015,7.718Z"
              transform="translate(-10.273 -10.364)"
            />
            <path
              fill={fill}
              d="M148.821,38.462c-.321-.794-.325-.8.46-1.108a20.833,20.833,0,0,1,9.774-1.371,21.124,21.124,0,0,1,16.832,10.866,20.732,20.732,0,0,1,2.716,12.5,21.572,21.572,0,0,1-16.039,18.959,21.319,21.319,0,0,1-14.323-1.206c-.6-.267-.6-.277-.32-.9.028-.062.047-.129.071-.194.4-.673.4-.674,1.133-.357a19.635,19.635,0,0,0,10.97,1.454,19.894,19.894,0,0,0,16.62-22.981,19.113,19.113,0,0,0-7.54-12.484,19.34,19.34,0,0,0-13.506-4.021,19.549,19.549,0,0,0-5.678,1.262C149.2,39.192,149.2,39.207,148.821,38.462Z"
              transform="translate(-127.275 -30.906)"
            />
            <path
              fill={fill}
              d="M147.511,92.827a.289.289,0,0,0,.048-.018c.269-.145.224-.654.587-.615.267.029.51.269.767.406a16.577,16.577,0,1,0,11.145-30.86,16.194,16.194,0,0,0-10.664,1.385c-.435.215-.692.258-.863-.258-.028-.086-.13-.148-.2-.222-.223-.777-.223-.777.554-1.147a18.247,18.247,0,1,1,11.746,34.3,18.074,18.074,0,0,1-12.943-1.956c-.422-.233-.575-.429-.227-.831C147.5,92.975,147.5,92.892,147.511,92.827Z"
              transform="translate(-126.875 -51.444)"
            />
            <circle
              fill={fill}
              cx="4.811"
              cy="4.811"
              r="4.811"
              transform="translate(23.694 13.985)"
            />
            <rect
              fill={fill}
              width="1.618"
              height="1.618"
              rx="0.809"
              transform="translate(29.404 13.696) rotate(180)"
            />
            <rect
              fill={fill}
              width="1.618"
              height="1.618"
              rx="0.809"
              transform="translate(23.405 19.606) rotate(180)"
            />
            <rect
              fill={fill}
              width="1.618"
              height="1.618"
              rx="0.809"
              transform="translate(35.3 19.606) rotate(180)"
            />
            <rect
              fill={fill}
              width="1.618"
              height="1.618"
              rx="0.809"
              transform="translate(34.099 14.828) rotate(135)"
            />
            <rect
              fill={fill}
              width="1.618"
              height="1.618"
              rx="0.809"
              transform="translate(29.404 25.574) rotate(180)"
            />
            <rect
              fill={fill}
              width="1.618"
              height="1.618"
              rx="0.809"
              transform="translate(32.954 23.969) rotate(-135)"
            />
            <rect
              fill={fill}
              width="1.618"
              height="1.618"
              rx="0.809"
              transform="translate(24.329 13.684) rotate(45)"
            />
            <rect
              fill={fill}
              width="1.618"
              height="1.618"
              rx="0.809"
              transform="translate(23.184 22.824) rotate(-45)"
            />
            <circle
              fill={fill}
              cx="3.752"
              cy="3.752"
              r="3.752"
              transform="translate(32.57 28.796)"
            />
            <rect
              fill={fill}
              width="1.262"
              height="1.262"
              rx="0.631"
              transform="translate(37.023 28.572) rotate(180)"
            />
            <rect
              fill={fill}
              width="1.262"
              height="1.262"
              rx="0.631"
              transform="translate(32.346 33.178) rotate(180)"
            />
            <rect
              fill={fill}
              width="1.262"
              height="1.262"
              rx="0.631"
              transform="translate(41.62 33.178) rotate(180)"
            />
            <rect
              fill={fill}
              width="1.262"
              height="1.262"
              rx="0.631"
              transform="translate(40.684 29.454) rotate(135)"
            />
            <rect
              fill={fill}
              width="1.262"
              height="1.262"
              rx="0.631"
              transform="translate(37.023 37.833) rotate(180)"
            />
            <rect
              fill={fill}
              width="1.262"
              height="1.262"
              rx="0.631"
              transform="translate(39.792 36.581) rotate(-135)"
            />
            <rect
              fill={fill}
              width="1.262"
              height="1.262"
              rx="0.631"
              transform="translate(33.064 28.561) rotate(45)"
            />
            <rect
              fill={fill}
              width="1.262"
              height="1.262"
              rx="0.631"
              transform="translate(32.173 35.69) rotate(-45)"
            />
            <circle
              fill={fill}
              cx="2.505"
              cy="2.505"
              r="2.505"
              transform="translate(22.672 28.475)"
            />
            <rect
              fill={fill}
              width="0.842"
              height="1.109"
              rx="0.421"
              transform="translate(25.646 28.591) rotate(180)"
            />
            <rect
              fill={fill}
              width="1.112"
              height="0.842"
              rx="0.421"
              transform="translate(22.792 31.401) rotate(180)"
            />
            <rect
              fill={fill}
              width="1.13"
              height="0.842"
              rx="0.421"
              transform="translate(28.715 31.401) rotate(180)"
            />
            <rect
              fill={fill}
              width="1.105"
              height="0.842"
              rx="0.421"
              transform="translate(28.089 28.913) rotate(135)"
            />
            <rect
              fill={fill}
              width="0.842"
              height="1.213"
              rx="0.421"
              transform="translate(25.646 34.508) rotate(180)"
            />
            <rect
              fill={fill}
              width="1.134"
              height="0.842"
              rx="0.421"
              transform="translate(27.494 33.674) rotate(-135)"
            />
            <rect
              fill={fill}
              width="0.842"
              height="0.842"
              rx="0.421"
              transform="translate(23.001 28.319) rotate(45)"
            />
            <rect
              fill={fill}
              width="0.842"
              height="0.842"
              rx="0.421"
              transform="translate(22.407 33.078) rotate(-45)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
